import { StudentCoursesDataT } from "@interfaces/internal-study/students";
import React from "react";
import clsx from "clsx";
import style from "@scss/pages/study-center.module.scss";
import { CourseItem } from "./course-item";

type CoursesItemsPropsT = {
  items: StudentCoursesDataT[];
};

const Courses: React.FC<CoursesItemsPropsT> = ({ items }) => {
  return (
    <div className={clsx(style.student_courses)}>
      {items.map((item) => (
        <CourseItem key={item.id} course={item} />
      ))}
    </div>
  );
};

export default Courses;
